class Instances {
    constructor(_request) {
        this._request = _request;
    }

    deployed() {
        return this._request.fetch({
            method: "GET",
            endpoint: "instances/deployed"
        });
    }

    with_workers(_workers) {
        return this.request.fetch({
            method: "GET",
            endpoint: "instances/with-workers"
        });
    }
}

export default Instances;
